<template>
  <canvas ref="chart" height="350" />
</template>
<script>
import { Chart } from 'chart.js'

export default {
  props: ['data', 'options'],
  data: () => {
    return {
      chart: null,
    }
  },
  watch: {
    data: {
      handler(newData) {
        this.chart.data = this.generateData(newData)
        this.chart.update()
      },
    },
  },
  mounted() {
    const ctx = this.$refs.chart.getContext('2d')
    this.chart = new Chart(ctx, {
      type: 'bar',
      data: this.generateData(this.data),

      options: {
        ...this.options,
        categoryPercentage: 0.8,
        barPercentage: 0.9,
        maintainAspectRatio: false,
        plugins: {
          legend: {
            display: false,
          },
          tooltip: {
            padding: 7,
            caretSize: 8,
            bodyFont: {
              size: 20,
            },
            xAlign: 'center',
            yAlign: 'bottom',
            displayColors: false,
            callbacks: {
              title: function (_) {
                return null
              },
            },
          },
        },
        scales: {
          x: {
            grid: {
              drawBorder: false,
              title: false,
              display: false,
              color: '#F5F5F5',
            },
            ticks: {
              font: {
                family: 'Source Sans Pro',
                size: 16,
              },
              color: '#333333',
            },
          },

          y: {
            grid: {
              drawBorder: false,
              color: '#F5F5F5',
            },
            ticks: {
              font: {
                family: 'Source Sans Pro',
                size: 16,
              },
              color: '#333333',
            },
          },
        },
      },
    })
  },

  methods: {
    generateData(data) {
      return {
        ...data,
        datasets: data.datasets.map((set, i) => ({
          backgroundColor: i % 2 === 0 ? '#F9D7CE' : '#CEE4F2',
          hoverBackgroundColor: i % 2 === 0 ? '#F9D7CE' : '#CEE4F2',
          ...set,
        })),
      }
    },
  },
}
</script>
